<template>
  <div class="gylc_content">
    <el-row type="flex" justify="space-around" style="width: 100%; height: 49%">
      <template v-for="(item, index) in list">
        <div class="gylc_block" :key="index">
          <countTo
            class="gylc_desc"
            :startVal="0"
            :endVal="item.num"
            :duration="3000"
          ></countTo>
          <img
            :src="imgs['img0' + (index + 1)]"
            alt=""
            class="gylc_img sbgl_animation"
          />
          <span class="gylc_desc_title">{{ item.processName }}</span>
        </div>
        <div
          class="gylc_line"
          v-if="index != list.length - 1"
          :key="index + 1000"
        >
          <img :src="imgs.imgline" alt="" />
        </div>
      </template>
      <!-- <div class="gylc_block">
        <countTo
          class="gylc_desc"
          :startVal="0"
          :endVal="totalCounts.total01"
          :duration="3000"
        ></countTo>
        <img :src="imgs.img01" alt="" class="gylc_img sbgl_animation" />
        <span class="gylc_desc_title">粗磨</span>
      </div>
      <div class="gylc_line">
        <img :src="imgs.imgline" alt="" />
      </div>
      <div class="gylc_block">
        <countTo
          class="gylc_desc"
          :startVal="0"
          :endVal="totalCounts.total02"
          :duration="3000"
        ></countTo>
        <img :src="imgs.img02" alt="" class="gylc_img sbgl_animation" />
        <span class="gylc_desc_title">插削</span>
      </div>
      <div class="gylc_line">
        <img :src="imgs.imgline" alt="" />
      </div>
      <div class="gylc_block">
        <countTo
          class="gylc_desc"
          :startVal="0"
          :endVal="totalCounts.total03"
          :duration="3000"
        ></countTo>
        <img :src="imgs.img03" alt="" class="gylc_img sbgl_animation" />
        <span class="gylc_desc_title">车削</span>
      </div>
      <div class="gylc_line">
        <img :src="imgs.imgline" alt="" />
      </div>
      <div class="gylc_block">
        <countTo
          class="gylc_desc"
          :startVal="0"
          :endVal="totalCounts.total04"
          :duration="3000"
        ></countTo>
        <img :src="imgs.img04" alt="" class="gylc_img sbgl_animation" />
        <span class="gylc_desc_title">铣削</span>
      </div>
    </el-row>
    <el-row type="flex" justify="space-around" style="width: 100%; height: 49%">
      <div class="gylc_block">
        <countTo
          class="gylc_desc"
          :startVal="0"
          :endVal="totalCounts.total05"
          :duration="3000"
        ></countTo>
        <img :src="imgs.img05" alt="" class="gylc_img sbgl_animation" />
        <span class="gylc_desc_title">钻削</span>
      </div>
      <div class="gylc_line">
        <img :src="imgs.imgline" alt="" />
      </div>
      <div class="gylc_block">
        <countTo
          class="gylc_desc"
          :startVal="0"
          :endVal="totalCounts.total06"
          :duration="3000"
        ></countTo>
        <img :src="imgs.img06" alt="" class="gylc_img sbgl_animation" />
        <span class="gylc_desc_title">磨削</span>
      </div>
      <div class="gylc_line">
        <img :src="imgs.imgline" alt="" />
      </div>
      <div class="gylc_block">
        <countTo
          class="gylc_desc"
          :startVal="0"
          :endVal="totalCounts.total07"
          :duration="3000"
        ></countTo>
        <img :src="imgs.img07" alt="" class="gylc_img sbgl_animation" />
        <span class="gylc_desc_title">镗削</span>
      </div>
      <div class="gylc_line">
        <img :src="imgs.imgline" alt="" />
      </div>
      <div class="gylc_block">
        <countTo
          class="gylc_desc"
          :startVal="0"
          :endVal="totalCounts.total08"
          :duration="3000"
        ></countTo>
        <img :src="imgs.img08" alt="" class="gylc_img sbgl_animation" />
        <span class="gylc_desc_title">刨削</span>
      </div> -->
    </el-row>
  </div>
</template>
<script>
import countTo from 'vue-count-to'
import { getProcesses } from '@/api/index'
export default {
  components: {
    countTo
  },
  data () {
    return {
      totalCounts: {
        total01: 120,
        total02: 5,
        total03: 89,
        total04: 12,
        total05: 140,
        total06: 45,
        total07: 36,
        total08: 72,
      },
      imgs: {
        img01: require('@/assets/imgs/01.png'),
        img02: require('@/assets/imgs/02.png'),
        img03: require('@/assets/imgs/03.png'),
        img04: require('@/assets/imgs/04.png'),
        img05: require('@/assets/imgs/05.png'),
        img06: require('@/assets/imgs/06.png'),
        img07: require('@/assets/imgs/07.png'),
        img08: require('@/assets/imgs/08.png'),
        imgline: require('@/assets/imgs/line.png'),
      },
      list: []
    }
  },
  mounted () {
    this.getProcessess()
  },
  methods: {
    async getProcessess () {
      let result = await getProcesses({})
      console.log(result)
      if (result.code == 200) {
        this.$set(this, 'list', result.data)
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.gylc_content {
  width: 100%;
  height: 100%;
  display: flex;
  align-content: space-between;
  flex-wrap: wrap;
  .gylc_block {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .gylc_desc {
    font-family: DIN;
    font-weight: bold;
    font-size: 24px;
    color: #ffffff;
    background: linear-gradient(180deg, #5baed0 0.341796875%, #90e5e8 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: breathLampScale 2s alternate infinite;
  }
  .gylc_img {
    width: 90px;
    height: 125px;
    margin-top: -37px;
    margin-bottom: -26px;
    animation: breathLamp 2s alternate infinite;
  }
  .gylc_line {
    display: flex;
    flex-direction: column;
    justify-content: center;
    img {
      height: 67px;
    }
  }
  .gylc_desc_title {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
  }
}
@keyframes breathLamp {
  0% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}
@keyframes breathLampScale {
  0% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(0.9);
  }
}
.sbgl_animation {
  animation: breathLamp 2s alternate infinite;
}
@keyframes breathLamp {
  // 0% {
  //   opacity: 0.2;
  // }
  // 100% {
  //   opacity: 1;
  // }
  0% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(0.9);
  }
}
</style>